import { apiRequest } from '@/utils/api-request';
import { useOrgStore } from '@/stores/org-store';

export interface GenerateApiKeyProps {
  name: string;
  description: string;
}

export const generateApiKey = async ({
  name,
  description,
}: GenerateApiKeyProps) => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  const response = await apiRequest({
    url: `/internal-api-keys/${orgId}`,
    method: 'POST',
    target: 'platform',
    body: {
      name,
      description,
    },
  });

  if (response?.detail) {
    throw new Error(response.detail || 'Failed to generate api key');
  }

  return response;
};
